      
import { createApiSlice } from 'app/createApiSlice'
import {
  API_FINDORA_COMPLIANCE,
  API_FINDORA_COMPLIANCE_EXPLAIN,
  API_FINDORA_COMPLIANCE_PERMISSION_ASK,
  API_FINDORA_COMPLIANCE_PERMISSION,
  API_SHARED_COMPLIANCE,
} from 'utils/apiList'

export const findoraDashboardListApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'findoraDashboardList/api',
  endpoints(builder) {
    return {
      fetchFindoraDashboardList: builder.query({
        query({ month, year, group, refresh }) {
          const params = {
            month,
            year,
            onlyActive: true, // FOR SHOWING USER ACTIVE
          }
          if (group && group !== 'All' && group !== 'Semua' && group !== 'Semua Group') {
            params.group = group
          }
          if (refresh) params.refresh = true
          return {
            url: `/${API_FINDORA_COMPLIANCE}`,
            params,
          }
        },
      }),
      fetchSharedComplianceList: builder.query({
        query() {
          return {
            url: `/${API_SHARED_COMPLIANCE}`,
            params: { page: 0, size: 100 },
          }
        },
      }),
      fetchSharedCompliance: builder.query({
        query({ resourceId, month, year, refresh }) {
          return {
            url: `/${API_SHARED_COMPLIANCE}/${resourceId}`,
            params: { month, year, onlyActive: true, refresh: refresh || undefined },
          }
        },
      }),
      fetchComplianceExplain: builder.query({
        query({ scope = 'member', field, detailData }) {
          return {
            url: `/${API_FINDORA_COMPLIANCE_EXPLAIN}`,
            method: 'POST',
            body: {
              scope,
              field,
              detailData,
            },
          }
        },
      }),
      askCompliancePermission: builder.mutation({
        query() {
          return {
            url: `/${API_FINDORA_COMPLIANCE_PERMISSION_ASK}`,
            method: 'POST',
          }
        },
      }),
      grantCompliancePermission: builder.mutation({
        query(body) {
          return {
            url: `/${API_FINDORA_COMPLIANCE_PERMISSION}`,
            method: 'POST',
            body,
          }
        },
      }),
    }
  },
})

// Rebuilds the baked report on the API (refresh=true) and shows the result
// under the args the page already uses, without a second request
export const refreshComplianceReport = (endpoint, args) => async (dispatch) => {
  const { endpoints, util } = findoraDashboardListApiSlice
  const data = await dispatch(
    endpoints[endpoint].initiate(
      { ...args, refresh: true },
      { subscribe: false, forceRefetch: true },
    ),
  ).unwrap()
  dispatch(util.upsertQueryData(endpoint, args, data))
}

export const {
  useFetchFindoraDashboardListQuery,
  useLazyFetchFindoraDashboardListQuery,
  useFetchSharedComplianceListQuery,
  useFetchSharedComplianceQuery,
  useFetchComplianceExplainQuery,
  useLazyFetchComplianceExplainQuery,
  useAskCompliancePermissionMutation,
  useGrantCompliancePermissionMutation,
} = findoraDashboardListApiSlice

    